import Fuse from 'fuse.js'

import {
  MaterialRowContent,
  PricingRowContent,
  ProviderInfoRowContent,
  ShippingTableRowContent,
} from '../types'

import {FilterOption} from '../containers/filters/string-matching-filter-partial'

import {
  CreditNoteRowContent,
  CreditNoteV2RowContent,
  InvoiceRowContent,
  InvoiceV2RowContent,
  OrderRowContent,
} from '../order-types'

export const createProviderInfoSearch = (providerInfoTableRows: ProviderInfoRowContent[]) => {
  const fuse = new Fuse(providerInfoTableRows, {
    shouldSort: true,
    threshold: 0.3,
    keys: ['name'],
  })

  return {
    search: (term: string) => fuse.search(term).map(result => result.item),
  }
}

export const createPricingSearch = (pricingTableRows: PricingRowContent[]) => {
  const fuse = new Fuse(pricingTableRows, {
    shouldSort: true,
    threshold: 0.3,
    keys: ['price.name'],
  })

  return {
    search: (term: string) => fuse.search(term).map(result => result.item),
  }
}

export const createShippingSearch = (shippingTableRows: ShippingTableRowContent[]) => {
  const fuse = new Fuse(shippingTableRows, {
    shouldSort: true,
    threshold: 0.3,
    keys: ['name'],
  })

  return {
    search: (term: string) => fuse.search(term).map(result => result.item),
  }
}

export const createMaterialSearch = (materials: MaterialRowContent[]) => {
  const fuse = new Fuse(materials, {
    shouldSort: true,
    threshold: 0.3,
    keys: ['name'],
  })

  return {
    search: (term: string) => fuse.search(term).map(result => result.item),
  }
}

export const createStringMatchingOptionsSearch = (options: FilterOption[]) => {
  const fuse = new Fuse(options, {
    shouldSort: true,
    threshold: 0.3,
    keys: ['searchable'],
  })

  return {
    search: (term: string) => fuse.search(term).map(result => result.item),
  }
}

export const createOrderSearch = (orderTableRows: OrderRowContent[]) => {
  const fuse = new Fuse(orderTableRows, {
    shouldSort: true,
    threshold: 0.3,
    keys: ['orderNumber', 'customerName'],
  })

  return {
    search: (term: string) => fuse.search(term).map(result => result.item),
  }
}

export const createInvoiceSearch = (
  invoiceTableRows: (InvoiceRowContent | CreditNoteRowContent)[]
) => {
  const fuse = new Fuse(invoiceTableRows, {
    shouldSort: true,
    threshold: 0.3,
    keys: ['orderNumber'],
  })

  return {
    search: (term: string) => fuse.search(term).map(result => result.item),
  }
}

export const createInvoiceV2Search = (
  invoiceTableRows: (InvoiceV2RowContent | CreditNoteV2RowContent)[]
) => {
  const fuse = new Fuse(invoiceTableRows, {
    shouldSort: true,
    threshold: 0.3,
    keys: ['orderNumber'],
  })

  return {
    search: (term: string) => fuse.search(term).map(result => result.item),
  }
}
